import { Head } from "gemi/client";

import { GoogleAnalytics } from "./components/GoogleAnalytics";
import "./main.css";

interface Props {
  children: React.ReactNode;
  locale: string;
}

export default function RootLayout(props: Props) {
  return (
    <html lang={props.locale.split("-")[0]} suppressHydrationWarning>
      <Head />
      {/* Preload the app font so it wins the `font-display: optional` block
          window and text paints in Onest from the first frame (no FOUT swap).
          `crossOrigin` is required for the preload to match the CORS-mode font
          fetch; React 19 hoists this <link> into <head>. */}
      <link
        rel="preload"
        as="font"
        type="font/ttf"
        href="/Onest.ttf"
        crossOrigin="anonymous"
      />
      <body className="max-w-vw w-vw overflow-x-hidden">
        {props.children}
        {/* Google Analytics is first-party product analytics and loads app-wide, unconditionally (not
            consent-gated): every route nests under RootLayout. The consent-sensitive Meta signals live
            only on the funnel layouts, never here: the Pixel loads after consent, and the `_fbc`/`_fbp`
            click-id cookies are captured there in a consent-safe way (see metaClickIds). The bootstrap
            silences itself off the prod hosts (localhost, folio-qa). */}
        <GoogleAnalytics />
      </body>
    </html>
  );
}
